import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/DEPIX/DEPIX_01.png";
import Img_Two from "./../../../../sources/imgs/DEPIX/DEPIX_02.png";
import Img_Three from "./../../../../sources/imgs/DEPIX/DEPIX_03.png";
import Img_Four from "./../../../../sources/imgs/DEPIX/DEPIX_04.png";
import Img_Five from "./../../../../sources/imgs/DEPIX/DEPIX_05.png";
import Img_Six from "./../../../../sources/imgs/DEPIX/DEPIX_06.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function DEPIX (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> DEPIX.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Introducción a DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Depix</i> es una <span className="span-pink">herramienta</span> que permite <span className="span-blue">analizar</span> y <span className="span-blue">revertir parcialmente</span> la <span className="span-white">pixelación de imágenes</span>, con el fin de <span className="span-pink">recuperar</span> <span className="span-white">texto oculto</span>. Esto facilita la <span className="span-pink">extracción</span> de <span className="span-white">información valiosa</span> que podría <span className="span-pink">revelar</span> <i className="span-blue">nombres de usuarios</i>, <i className="span-blue">contraseñas</i>, <i className="span-blue">direcciones</i> o cualquier otro dato que un <span className="span-pink">atacante</span> podría usar para <span className="span-pink">comprender</span> mejor el <span className="span-white">objetivo</span>.
            </p>

            <p>
                Su uso dentro del <i className="span-yellow">hacking ético</i> no solo demuestra la <span className="span-white">importancia</span> de evaluar la efectividad de técnicas de <span className="span-white">anonimización visual</span>, sino que también forma parte de la <span className="span-pink">obtención</span> de <span className="span-white">inteligencia pasiva</span>, donde el analista recopila información sin interacción directa con los sistemas. Para que <i className="span-yellow">Depix</i> funcione correctamente, requiere una <span className="span-white">imagen de búsqueda</span>, que actúa como <span className="span-white">referencia</span> de los <span className="span-blue">caracteres posibles</span>, y la <span className="span-blue">imagen pixelada</span> que se desea <span className="span-white">analizar</span>.
            </p>

            <p>
                De esta forma, <i className="span-yellow">Depix</i> se convierte en un <span className="span-white">recurso valioso</span> en la <span className="span-pink">etapa de reconocimiento</span>, permitiendo que los <i className="span-yellow">profesionales de ciberseguridad</i> <span className="span-pink">identifiquen</span> <i className="span-blue">riesgos</i> y <i className="span-blue">evalúen</i> la exposición de <span className="span-white">información sensible</span> en <span className="span-white">imágenes supuestamente protegidas</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Instalación de DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <b className="span-blue">
                    1. Requisitos previos.
                </b>
            </p>

            <p>
                Antes de comenzar con la <span className="span-white">instalación</span> de <i className="span-yellow">Depixelization_poc</i> en <i className="span-yellow">Kali Linux</i>, es <span className="span-white">fundamental</span> asegurarse de que el sistema cuenta con todas las <span className="span-pink">dependencias necesarias</span>. Esta <span className="span-white">herramienta</span> está escrita en <i className="span-yellow">Python 3</i> y utiliza <span className="span-blue">librerías</span> que permiten <span className="span-pink">manipular</span> <span className="span-white">imágenes</span> y <span className="span-pink">realizar</span> <span className="span-white">cálculos matemáticos</span>.
            </p>

            <p>
                En <span className="span-pink">concreto</span>, <span className="span-white">necesitas</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-yellow">Python 3</i>, ya que el <span className="span-white">código del proyecto</span> está escrito en este <span className="span-pink">lenguaje</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-yellow">Git</span>, para poder <span className="span-yellow">clonar</span> el <span className="span-white">repositorio oficial</span> desde <i className="span span-pink">GitHub</i> <i className="span-white"><a href="https://github.com/spipm/Depixelization_poc.git" target="_blank" className="span-white">
                        (https://github.com/spipm/Depixelization_poc.git)</a></i>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-yellow">OpenCV</span> para <span className="span-yellow">Python</span>, que facilita el <span className="span-white">procesamiento de imágenes</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-yellow">Librerías</span> comunes de <span className="span-yellow">Python</span> como <i className="span-blue">numpy</i> <i className="span-white">(cálculo numérico)</i> y <i className="span-blue">pillow</i> <i className="span-white">(manipulación de imágenes)</i>.
                    </p>
                </li>
            </ul>

            <p>
                Para <span className="span-pink">instalarlas</span> en <i className="span-yellow">Kali Linux</i>, <span className="span-white">ejecuta</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt update"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install git python3 python3-pip python3-opencv"
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. DEPIX."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando de instalación de DEPIX."}
            />

            <p>
                <b className="span-blue">
                    2. Clonar el repositorio.
                </b>
            </p>

            <p>
                El <span className="span-white">código fuente</span> de la <span className="span-white">herramienta</span> <span className="span-pink">NO</span> se instala como un <span className="span-white">paquete tradicional</span>, sino que se <span className="span-pink">descarga</span> directamente desde <i className="span-yellow">GitHub</i>. Para ello se utiliza <i className="span-yellow">git</i>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "git clone https://github.com/spipm/Depixelization_poc.git"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "cd Depixelization_poc"
            />

            <p>
                Tal como se muestra, a <span className="span-white">continuación</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. DEPIX."}
                title = {"Descripcción de imagen."}
                text = {"2. Comando para clonación de repositorio de DEPIX."}
            />

            <p>
                <span className="span-yellow">Nota: </span>El <span className="span-white">primer comando</span> <span className="span-pink">clona</span> el <span className="span-white">proyecto</span> en tu <span className="span-white">máquina</span>, y el <span className="span-white">segundo</span> te posiciona <span className="span-pink">dentro</span> de la <span className="span-pink">carpeta</span> que contiene el <span className="span-white">código</span>.
            </p>

            <p>
                <b className="span-blue">
                    3. Instalar dependencias adicionales.
                </b>
            </p>

            <p>
                Una vez <span className="span-pink">dentro</span> de la <span className="span-white">carpeta del proyecto</span>, revisa si existe un <span className="span-white">archivo</span> llamado <i className="span-white">requirements.txt</i>. Este archivo suele <span className="span-pink">incluir</span> la <span className="span-white">lista completa de librerías</span> que el programa <span className="span-pink">necesita</span>.
            </p>

            <p>
                Si está <span className="span-white">presente</span>, <span className="span-pink">instálalas</span> de forma automática con:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "pip3 install -r requirements.txt"
            />

            <p>
                En caso de que <span className="span-pink">NO exista</span>, puedes <span className="span-pink">instalar</span> las <span className="span-white">librerías más importantes</span> de forma manual:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "pip3 install pillow numpy"
            />

            {/* <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Vesión de DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Ayuda de DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3> */}

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Uso de DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <b className="span-blue">
                    1. Sintaxis principal.
                </b>
            </p>

            <p>
                La <span className="span-white">herramienta</span> se ejecuta desde la <span className="span-white">terminal</span> mediante <i className="span-yellow">Python</i>, indicando los <span className="span-pink">parámetros necesarios</span>. La <span className="span-white">estructura general</span> del <span className="span-white">comando</span> es:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "python3 depix.py -p <imagen_pixelada> -s <imagen_busqueda> -o <imagen_salida>"
            />

            <p>
                En este <span className="span-white">comando</span>, debes <span className="span-pink">especificar</span> <span className="span-blue">tres rutas</span> de <span className="span-white">archivo</span>: la <i className="span-blue">imagen pixelada</i> que deseas <span className="span-pink">recuperar</span>, la <i className="span-blue">imagen de búsqueda</i> que servirá como <span className="span-pink">referencia</span>, y la <i className="span-blue">ruta de salida</i> donde se <span className="span-pink">almacenará</span> el <span className="span-white">resultado</span>.
            </p>

            <p>
                <b className="span-blue">
                    2. Parámetros importantes.
                </b>
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-white">-p</i> <span className="span-yellow">→</span> <span className="span-pink">Define la ruta de la imagen pixelada que quieres descifrar. Ejemplo: captura_pixelada.png.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">-s</i> <span className="span-yellow">→</span> <span className="span-pink">Indica la ruta de la imagen de búsqueda, que debe contener caracteres de referencia (ejemplo: searchimage.png).</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">-o</i> <span className="span-yellow">→</span> <span className="span-pink">Es la ruta donde se guardará la imagen reconstruida, ya sin pixelado (ejemplo: recovered.png).</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--backgroundcolor R,G,B</i> <span className="span-yellow">→</span> <span className="span-pink">Opción adicional que permite especificar un color de fondo, en caso de que sea necesario.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--averagetype</i> <span className="span-yellow">→</span> <span className="span-pink">Define el tipo de promedio usado en el proceso de pixelado. Por defecto es linear, que corresponde al método más común.</span>
                    </p>
                </li>
            </ul>

            <p>
                <span className="span-white">
                    Ejemplo
                </span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "python3 depix.py -p pixel_input.png -s search_seq.png -o recovered.png"
            />

            <p>
                <span className="span-white">Realizando</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. DEPIX."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando para uso de DEPIX."}
            />

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. DEPIX."}
                title = {"Descripcción de imagen."}
                text = {"4. Visualización de imagen correguida con DEPIX."}
            />

            <Img
                img = {Img_Five}
                alt = {"Imagen 4. DEPIX."}
                title = {"Descripcción de imagen."}
                text = {"4. Visualización de imagen pixeleada a correguir con DEPIX."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Herramientas adicionales incluidas dentro de DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                El <span className="span-pink">repositorio</span> también proporciona <span className="span-white">scripts auxiliares</span> que permiten <i className="span-blue">experimentar</i> y <i className="span-blue">verificar</i> el <span className="span-white">funcionamiento</span>:
            </p>

            <p>
                <b className="span-blue">
                    1. Mostrar bloques detectados:
                </b>
            </p>

            <p>
                Este <span className="span-white">comando</span> sirve para <span className="span-pink">comprobar</span> si la <span className="span-white">herramienta</span> está <span className="span-blue">reconociendo correctamente</span> los <span className="span-white">bloques de la pixelación</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "python3 tool_show_boxes.py -p pixel_input.png -s search_seq.png"
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. DEPIX."}
                title = {"Descripcción de imagen."}
                text = {"6. Visualización de imagen pixeleada con bloques detectados con DEPIX."}
            />

            {/* <p>
                <b className="span-blue">
                    2. Generar imagen pixelada de prueba:
                </b>
            </p>

            <p>
                Si deseas hacer <span className="span-white">pruebas</span>, puedes tomar una <span className="span-white">imagen limpia</span> y <span className="span-pink">convertirla</span> en una <span className="span-white">versión pixelada</span> con este <span className="span-pink">script</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "python3 tool_gen_pixelated.py -i original.png -o pixelada.png"
            />

            <p>
                Esto es <span className="span-white">útil</span> para entender cómo <span className="span-pink">trabaja</span> la <span className="span-white">herramienta</span> y <i className="span-blue">validar</i> que el <span className="span-white">flujo</span> funciona.
            </p> */}

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Preparar “imagen de búsqueda” con DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Un <span className="span-pink">aspecto clave</span> de esta <span className="span-white">herramienta</span> es la <span className="span-white">imagen de búsqueda</span> <i className="span-white"> (-s)</i>. El <span className="span-white">programa</span> <span className="span-pink">NO</span> puede <span className="span-pink">reconstruir el texto</span> si no tiene una <span className="span-white">referencia clara</span> de cómo lucen los <span className="span-white">caracteres</span> antes de ser <span className="span-pink">pixelados</span>. Por lo tanto, tú mismo debes <span className="span-pink">crear</span> <span className="span-white">esta imagen</span>.
            </p>

            <p>
                El <span className="span-white">proceso recomendado</span> es el <span className="span-white">siguiente</span>:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Escribe</span> en un <span className="span-white">documento</span> <span className="span-pink">TODOS</span> los <span className="span-white">caracteres</span> que crees que aparecen en la <span className="span-white">imagen pixelada</span>: <span className="span-white">letras</span> <i className="span-pink">(a–z)</i>, <span className="span-white">números</span> <i className="span-pink">(0–9)</i> y <span className="span-white">símbolos</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Asegúrate</span> de utilizar la <span className="span-white">MISMA fuente tipográfica</span>, <i className="span-blue">tamaño</i> y <i className="span-blue">color</i> que el <span className="span-white">texto original</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Realiza</span> una <span className="span-white">captura de pantalla</span> de este <span className="span-white">texto</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Guarda</span> esa <span className="span-white">captura</span> con un <span className="span-white">nombre sencillo</span>, por <span className="span-white">ejemplo</span>, <i className="span-white">searchimage.png</i>.
                    </p>
                </li>
                <li>
                    <p>
                        Usa este <span className="span-white">archivo</span> como argumento en el <span className="span-pink">parámetro</span> <i className="span span-white">-s</i>.
                    </p>
                </li>
            </ol>

            <p>
                De esta <span className="span-white">manera</span>, el <span className="span-white">programa</span> puede comparar cada <span className="span-white">bloque pixelado</span> con los <span className="span-pink">caracteres</span> de tu <span className="span-white">imagen de referencia</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Limitaciones con DEPIX.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Aunque <span className="span-pink">poderosa</span>, la <span className="span-white">herramienta</span> tiene <span className="span-blue">limitaciones</span> que debes <span className="span-white">considerar</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">SOLO funciona</span> con <span className="span-blue">pixelación por box filter lineal</span>, es decir, <span className="span-white">bloques cuadrados promedio</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">NO es compatible</span> con <i className="span-blue">difuminado (blur)</i>, <i className="span-blue">pixelación irregular</i> o <i className="span-blue">técnicas avanzadas</i> como <i className="span-white">sub-pixel rendering</i>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Es obligatorio</span> que la <span className="span-white">fuente de la imagen de búsqueda</span> <span className="span-pink">coincida</span> con la <span className="span-white">fuente original</span>.
                    </p>
                </li>
                <li>
                    <p>
                        En <span className="span-white">imágenes con compresión muy agresiva</span>, como <i className="span-blue">JPEG</i> con alta pérdida, los resultados pueden ser <i className="span-blue">poco útiles</i> o <i className="span-blue">fallar</i> por completo.
                    </p>
                </li>
            </ul>

            <p>
                En <span className="span-white">resumen</span>, <i className="span-yellow">Depixelization_poc</i> es una <span className="span-white">prueba de concepto</span> que permite <span className="span-pink">revertir pixelación</span> en textos siempre que prepares correctamente una <span className="span-white">imagen de referencia</span>. No reconstruye mágicamente cualquier <span className="span-white">imagen</span>, sino que depende de la <span className="span-white">similitud</span> entre la <i className="span-blue">imagen pixelad</i>a y los <i className="span-blue">caracteres</i> que le proporciones como <span className="span-white">guía</span>.
            </p>

        </>
    );
}